const EventTypesStyles = (theme) => ({
    shrinkedLabelStyle: {
        position: 'absolute',
        top: 0,
        left: 0,
        marginLeft: '5px'
    },
    normalLabelStyle: {
        position: 'absolute',
        marginTop: '10px',
        top: 0,
        left: 0
    }
});

export default EventTypesStyles;
